import { Paper, styled } from '@mui/material';

export const AppLayout = styled('div')(({ theme }) => ({
  margin: 0,
  padding: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: theme.palette.background.default,
}));

export const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
}));
